import { Typography } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

import chairIcon from '../../media/chair_icon.svg'
const ChairTitle = ({ label }) => {
	return (
		<Typography
			component="h6"
			sx={(theme) => ({
				fontSize: 22,
				fontWeight: 800,
				color: 'text.primary',
				mb: 2,
				background: (theme) => `url(${chairIcon}) no-repeat ${theme.spacing(0, 1)}`,
				pl: 4.5,
				display: 'table',
				[theme.breakpoints.down('md')]: {
					fontSize: 19,
					backgroundPositionY: 6,
					backgroundSize: 15,
					pl: 3,
					fontWeight: 900,
				},
			})}
		>
			{label}
		</Typography>
	)
}

ChairTitle.propTypes = {
	label: PropTypes.string.isRequired,
}

export default ChairTitle
